/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invitation_Already_AcceptedInputs */

const fr_error_invitation_already_accepted = /** @type {(inputs: Error_Invitation_Already_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce lien a déjà servi. Connectez-vous plutôt avec votre mot de passe.`)
};

const en_error_invitation_already_accepted = /** @type {(inputs: Error_Invitation_Already_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link has already been used. Sign in with your password instead.`)
};

/**
* | output |
* | --- |
* | "This link has already been used. Sign in with your password instead." |
*
* @param {Error_Invitation_Already_AcceptedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_invitation_already_accepted = /** @type {((inputs?: Error_Invitation_Already_AcceptedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invitation_Already_AcceptedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_invitation_already_accepted(inputs)
	return fr_error_invitation_already_accepted(inputs)
});